import {EntityFollowedEvent} from './EntityFollowedEvent';

export class MatchFollowed extends EntityFollowedEvent {}
